module.exports = __webpack_public_path__ + "static/logo-georges-61daa1f503c3e08e7178fd968c253bec.png";